// @flow
import React from 'react'
import styled from 'styled-components'

import { Super } from '../../typography'

import { myTheme, themedTextColor, themedTextColorRgb } from '../../../styles'
import { addRef, addHash } from './endnotes.service'

type Props = {
  id: string,
  index: number,
}

const { borderRadii, fontSize, space } = myTheme

const StyledSuperLink = styled.a`
  background-color: rgba(${themedTextColorRgb}, 0.1);
  border-radius: ${borderRadii.one};
  color: ${themedTextColor};
  display: inline-block;
  font-size: ${fontSize.eight};
  line-height: 0;
  margin-left: calc(${space.half} / 2);
  position: relative;
  top: -0.5em;

  /*
    Theme Exception:

    Because of how small the footnotes I needed to work at a smaller scale than
    my space scale would allow.
  */
  padding: calc(${space.one} - 0.1rem) calc(${space.half} - 0.05rem);
`

const EndnoteSuperLink = ({ id, index }: Props) => (
  <StyledSuperLink
    aria-describedby="footnote-label"
    href={addHash(id)}
    id={addRef(id)}
  >
    <Super>{index}</Super>
  </StyledSuperLink>
)

export default EndnoteSuperLink



// WEBPACK FOOTER //
// ./src/components/typography/endnotes/endnote-super-link.js